/* @refresh reload */
import '@forest/shared/polyfills'

import './setup'
import './index.css'

import { QueryClientProvider } from '@tanstack/solid-query'
import { render } from 'solid-js/web'
import { App } from './app'
import { shouldUseMockAPI } from './lib/params'
import { mark } from './lib/perf'
import { queryClient } from './lib/query-client'

async function enableMocking() {
  const { configureMockNativeServices, worker } = await import('./mocks')
  configureMockNativeServices()
  return worker.start({ onUnhandledRequest: 'bypass' })
}

async function boot() {
  if (shouldUseMockAPI) await enableMocking()
  mark('render:start')
  render(
    () => (
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    ),
    document.getElementById('root')!,
  )
  mark('render:done')
}

void boot()
